<template>
  <div>
     <div style="text-align: center; width: 370px">
      <img
        src="./../../assets/u35.png"
        style="margin: 0 auto"
        height="50%"
        width="50%"
      />
    </div> 

    <div style="width: 80%;margin: 0px auto">
        <van-field
        clearable
          v-model="user"
          maxlength="11"
          left-icon="friends"
          placeholder="请输入账号"
          :rules="[
            { required: true, message: '请输入账号' },
          ]"
        />
      <van-cell-group>
        <van-field
          clearable
          type="password" 
          v-model="password"
          left-icon="lock"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请输入密码' }]"
        />
      </van-cell-group>
      <!-- <van-cell-group>
        <a style="float:right">
        忘记密码
        </a>
      </van-cell-group> -->
    </div>
    <div class="button-group" style="width: 80%; margin: 2px auto">
      <van-button
        round
        type="danger"
        size="normal"
        @click="loginOrRegister"
        style="width: 100%;height:3.4rem"
        >
        立即登录
      </van-button>
    </div>
    <!-- <div>
      <van-divider>OR</van-divider>
    </div> -->
    <div class="button-group" style="width: 80%; margin: 2px auto">
      <van-button round style="width: 100%;height:3rem"  type="primary"
       @click="getmodel('institutionsCollection')">
        单位数据录入
      </van-button>
    </div> 
  </div>
</template>
<script>
import md5 from 'js-md5';
import {
  Button,
  Cell,
  CellGroup,
  Col,
  Dialog,
  Divider,
  Field,
  Form,
  Icon,
  Row,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Toast
} from "vant";

export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [Divider.name]: Divider
  },
  data() {
    return {
      hasSendSms: false,
       user: localStorage.getItem("sanitationUsername"),
       password:localStorage.getItem("password"),
      smsCode: "",
      second: 300,
      mobile: "",
      loginloading: false,
    };
  },
  mounted() {
   
  },
  methods: {
    sendSms() {
      this.hasSendSms = true;

      this.$axios
        .post("/common/" + this.mobile + "/addNewSmsrecorder")
        .then((data) => {
          if (data.code == 200) {
            Toast(data.message);
            sessionStorage.setItem(
              "checkednum",
              JSON.stringify({
                checkednum: data.data,
                time: Date.now(),
              })
            ); //保存验证码备用
            this.setTimeOut();
          } else {
            Toast(data.message);
          }
        })
        .catch((erro) => {
          reject(erro);
        });

      //})
    },
    setTimeOut() {
      let timer = setTimeout(() => {
        this.setTimeOut();
        if (this.second > 0) {
          this.second--;
        }
      }, 1000);
      if (this.second <= 0) {
        this.hasSendSms = false;
        this.second = 300;
        clearTimeout(timer);
      }
    },
    validator(val) {
      return /^((13\d)|(14[5,7,9])|(15[0-3,5-9])|(166)|(17[0,1,3,5,7,8])|(18[0-9])|(19[8,9]))\d{8}/.test(
        val
      );
    },
    loginOrRegister(vals) {
      this.loginloading = true;
      let _this = this;
      let url = "/common/loginByPWD";
      setTimeout(() => {
        this.loginloading = false;
      }, 6000);
      return new Promise((resolve, reject) => {
        _this.$axios
          .post(url, {
            memMobileno: this.user, // 手机号
            memPassword: md5(this.password), // 微信openid
            // code: this.smsCode,
          })
          .then((data) => {
            if (data.code == 200) {
              Toast("登录成功");
              localStorage.setItem("password",this.password)
              localStorage.setItem("sanitationAccessToken", data.data.token);
              localStorage.setItem("sanitationUsername",this.user);
              sessionStorage.setItem("id", data.data.id);
              localStorage.setItem("role", data.data.role);
              localStorage.setItem("memName", data.data.memName);
              this.$appConfig.roleState =(data.data.role==="收费人员"?true:false)
              if(data.data.role === "收费人员"){
                this.$router.push({ path: "/home" });
              }else if(data.data.role === "录入人员"){
                this.$router.push({ path: "/customerList" });
              }
            } else {
              Toast(data.message);
              this.loginloading = false;
            }
          })
          .catch((erro) => {
            reject(erro);
          });
      });
      this.$router.push({ path: "/home" });
    },
  },
};
</script>

<style lang="less">
.button-group {
  // margin: 15px;
  .van-button {
    margin-top: 10px;
  }
}
.van-field__left-icon .van-icon, .van-field__right-icon .van-icon {
    font-size: 28px;
}
.user {
  &-poster {
    width: 100%;
    display: block;
  }
.van-field__left-icon {
    margin-right: 24px;
}
  &-group {
    margin-bottom: 15px;
  }
  .van-cell{
    background-color: #f8f8f8 !important;
  }
  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
// .img1{
//   background-size: 100% 100%;
//   background: url('../../assets/img/banner.png') center center no-repeat;
//   height: 100%;
//   position: fixed;
//   width: 100%
// }
</style>
